<div class="container-div" *ngIf="sdkInitTexts">
  <div class="container-fluid px-0">
    <div class="row  mx-0 my-0 h-100">
      <div class="col-12 px-0 d-flex justify-content-center">
        <div *ngIf="errorMessage" class="error-message">
          <pa-message [description]="errorMessage" (messageState)="messageState($event)"></pa-message>
        </div>
      </div>
      <div class="col-12 px-0 d-flex justify-content-center">
        <div class="rectangle">
          <p class="title">{{this.textService.keyValueMapping('loginHeader', 'Üye Girişi', this.sdkInitTexts)}}</p>
          <p
            class="description">{{loginDescription}}
            <br><span
              class="text-style">{{loginDescriptionContinue}}</span>
          </p>
          <form [formGroup]="phoneLoginForm" (ngSubmit)="checkPhoneNumber()">
            <div class="col-12 px-0 d-flex">
              <mat-form-field class="input-style">
                <input type="tel"
                       [placeholder]="this.textService.keyValueMapping('loginGsmLabel', 'Telefon Numarası',this.sdkInitTexts)"
                       formControlName="phoneNumber" autocomplete="off" mask="(000) 000 00 00"
                       maxlength="15"
                       matInput
                       myAutofocus
                       [readonly]="validMsisdn">
                <mat-error
                  *ngIf="phoneLoginForm.controls.phoneNumber.errors && phoneLoginForm.controls.phoneNumber.errors.required">
                  {{this.textService.keyValueMapping('msgLoginGsm', 'Lütfen Telefon Numaranızı Giriniz.', this.sdkInitTexts)}}
                </mat-error>
                <mat-error
                  *ngIf="phoneLoginForm.controls.phoneNumber.errors && phoneLoginForm.controls.phoneNumber.errors.pattern">
                  {{this.textService.keyValueMapping('msgLoginGsmRule', 'Telefon Numaranızın ilk rakamı 5 ile başlamalı ve 10 haneli olmalıdır.', this.sdkInitTexts)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-12 px-0 d-flex">
              <div class="information d-flex" *ngIf="isLoginWebSdk">
                <div>
                  <img class="info" [src]="'assets/images/info.png'" [srcset]="'assets/images/info@2x.png 2x, assets/images/info@3x.png 3x'" alt="logo">
                </div>
                <div>
                  <label class="text-style">{{this.textService.keyValueMapping('finansmanInfo', 'Gsm bilginiz Turkcell Finansman A.Ş ile paylaşılacaktır.', this.sdkInitTexts)}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 px-0 d-flex">
              <button type="submit" class="button-style"><span
                class="text-style">{{buttonName}}</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="push"></div>
  </div>
  <footer class="footer">
    <div class="path"></div>
    <div class="w-100 justify-content-center text-center">
      <label class="what-is-paycell"
             (click)="createTplModal()"><a>{{this.textService.keyValueMapping('whatsPaycellButton', 'Paycell Nedir?', this.sdkInitTexts)}}</a></label>
    </div>
  </footer>
</div>
